<template>
  <div v-show="show" :style="{ 'z-index': (currentZIndex-1)}">
    <div :style="{ 'z-index': (currentZIndex)}"
      class="dimmed_black" style="top:0;display:block;"></div>
    
    <div :style="{ 'z-index': (currentZIndex+1)}"
      class="rew19_popContainer big" style="display:block;">

      <div class="rew19_popup_wrap">
        <h2>
          <span class="rew19_basketList_tit">리워드 마일리지 결제 신청</span>
          <button class="rew19_basketList_btn" @click="onCancel"><span>닫기</span></button>
        </h2>
      </div>

      <div class="rew19_popup_cont">
        <ul class="rew19_underline_list type4">
          <li class="type2">
            <em class="midType">보유 마일리지</em>
            <span class="substance">{{$fmt.PV(viewData.aro_info.ownMileage, "-")}}</span>
          </li>
          <li class="type2">
            <em class="midType">배송비 결제방법</em>
            <span class="substance">
              <div 
                v-if="'Y'==viewData.aro_info.mileage_delivery_status"
                class="rew19_wrapRadio_t1">
                <input v-model="viewData.orderDeliverWay"
                  value="M"
                  type="radio" class="rew19_fakeRadio_t1" id="orderDeliverWay_M">
                <label for="orderDeliverWay_M">마일리지 결제(2.1 마일리지 사용)</label>
              </div>
              <div class="rew19_wrapRadio_t1">
                <input v-model="viewData.orderDeliverWay"
                  value="C"
                  type="radio" class="rew19_fakeRadio_t1" id="orderDeliverWay_C">
                <label for="orderDeliverWay_C">신용카드 결제(3,080원 결제)</label>
              </div>
            </span>
          </li>
          <li class="type2">
            <em class="midType">사용예정 마일리지</em>
            <span v-if="AroConst.VALUE_fdeliverytype_MILEAGE == viewData.orderDeliverWay"
              class="substance">
                {{AroConst.VALUE_AGE_LOC_ME_CUSTOM_PRODUCT_MILEAGE_AND_DELIVERY_AMOUNT}} 마일리지
                <br/>(커스텀 프로덕트 세트 + 배송비)
            </span>
            <span v-else-if="AroConst.VALUE_fdeliverytype_CREDIT_CARD == viewData.orderDeliverWay"
              class="substance">
                {{AroConst.VALUE_AGE_LOC_ME_CUSTOM_PRODUCT_MILEAGE_AMOUNT}} 마일리지
                <br/>(커스텀 프로덕트 세트)
            </span>
          </li>
        </ul>

        <ul class="rew19_dotList skinCare">
          <li class="rew19_point">보유 마일리지가 총 134.5 이상이어야 합니다.</li>
          <li>결제일 하루 전까지만 신청 및 취소가 가능합니다.</li>
          <li>리워드 마일리지 결제 신청 시 1회만 마일리지로 결제 되며, 다음 회차 부터는 일반 결제로 자동 전환됩니다.</li>
          <li>현재 보유 마일리지가 충분하더라도 결제 시점에 확인된 마일리지가 부족할 경우 결제가 실패할 수 있습니다. 결제 실패 시 재결제를 진행해 주시기 바랍니다.</li>
        </ul>

        <dl v-show="AroConst.VALUE_fdeliverytype_CREDIT_CARD == viewData.orderDeliverWay"
          class="rew19_select_table rew19_addTop">
          <dt>
            <span class="rew19_table_tit">배송비 결제 신용카드 정보</span>
          </dt>

          <card-info            
            ref="cardInfoPanel"
            :showCardTerm="true"
            :checkTermIdNum="'2'"
          >
            <template slot="footer">
              <ul class="rew19_dotList topLine rew19_addTop">
                <li>해당 신용카드 정보는 배송비 결제만을 위한 카드 정보 입니다. 리워드 약정의 결제 정보는 변경되지 않습니다.</li>
              </ul>
            </template>
          </card-info>
        </dl>
                    
      </div><!--//rew19_popup_cont-->
      <div class="rew19_popup_btn rew19_clear">
        <button class="rew19_popHarf disabled" @click="onCancel">취소</button>
        <button class="rew19_popHarf activation" @click="onOk">확인</button>
      </div> 

    </div>
  </div>  
</template>
<script>
import AroBase from '@/components/base/AroBase';
import CardInfo from '@/components/control/CardInfo';
import * as ErrMsg from "@/utils/error_msg";
import * as AroConst from "@/utils/const";

const DEFAULT_VIEWDATA = {
  aro_info : {},

  orderDeliverWay : AroConst.VALUE_fdeliverytype_MILEAGE,

  card :{
    birth : null,    
    expMM : null,
    expYY : null,
    pwd : null,

    useAgree : false,
    isCheckCard : false,

    useTerm : ''
  },
};

export default {
  name: 'AgelocRewardMileagePaymentDialog',
  extends: AroBase,
  components: { CardInfo },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentZIndex : 2000,

      adr_no : null,

      viewData : {...DEFAULT_VIEWDATA},
    }
  },
  watch: {
    show(show) {
      this.$modalAfterTreat(show);

      show && this.$nextTick(() => {
        let _this = this;
        _this.currentZIndex = _this.$getDimmMaxIndex() + 2;

        this.$el.focus();
      })
    }
  },
  updated: function () {
    this.$nextTick(function () {
      $(".rew19_popContainer.big .rew19_popup_cont").css('height', $(window).height() - 102); 
    })
  },
  mounted() {
    let _this = this;

  },  
  methods :{
    onClose(response, resData) {
      let _this = this;

      _this.$emit('close', response, response ? resData: null);      
    },
    onCancel(){
      this.onClose(false);
    },
    onOk() {
      let _this = this;

      let retVal = {
        addpaymenttype : AroConst.VALUE_addpaymenttype_MILEAGE, //재결제 마일리지 사용
      };

      if(AroConst.VALUE_fdeliverytype_MILEAGE == _this.viewData.orderDeliverWay){
        //배송비 마일리지 사용
        retVal.delivery_typ = AroConst.VALUE_fdeliverytype_MILEAGE; //배송비 마일리지 사용

        _this.onClose(true, retVal);
        return;

      }else if(AroConst.VALUE_fdeliverytype_CREDIT_CARD == _this.viewData.orderDeliverWay){
        //배송비 신용카드 사용
        retVal.delivery_typ = AroConst.VALUE_fdeliverytype_CREDIT_CARD; //배송비 신용카드 사용

        //카드 입력폼 검증
        if(!_this.$refs.cardInfoPanel.validateCard()){
          return;
        }

        //카드 유효성 검사
        let card = _this.$refs.cardInfoPanel.getCardInfo();
        let cardInfo = {
          ccard_no : card.cardnumber,
          ccard_exp : card.expYY + card.expMM,
          birth_dt : card.birth,
          passwd : card.pwd
        };

        _this.$showLoading();        
        _this.apiCheckCardValidate(cardInfo).then(res=>{
          if(!(res.status === 200 && res.data.status === "0000")){
            //카드 유효성 검사 실패
            let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
            _this.$dialogs.alert(errMsg)
            .then(res => {});
            return;
          }

          //카드유효성 성공시
          retVal = {
            ...retVal,
            birth_dt : card.birth,
            card_no : card.cardnumber,
            card_exp : card.expYY + card.expMM,
            passwd : card.pwd,
          };

          _this.onClose(true, retVal);          

        }).catch((err)=>{          
          console.error(err);
          _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
          .then(res => {});        

        }).finally(()=>{
          _this.$hideLoading();
        });
      }
    },

    /**
     * API Request
     */    
    //카드 유효성 검사
    /**
     * cardInfo : {
     *  카드번호 : ccard_no[1111222233334444]
     *  카드유효기간 : ccard_exp[년/월(1904)]
     *  생년월일 : birth_dt[880101]
     *  비밀번호(앞2자리) : passwd[11]"
     * }
     */
    apiCheckCardValidate(cardInfo){
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/check_card_validate`, {
        params: {
          card_list : JSON.stringify([cardInfo])
        }        
      });
    },

    /**
     * Local 
     */
    initData : function(paramData){
      let _this = this;

      _this.adr_no = paramData.adr_no;

      _this.viewData = {
        ...DEFAULT_VIEWDATA,
        aro_info : paramData.aro_info,

        orderDeliverWay : 'Y'== paramData.aro_info.mileage_delivery_status ? "M" : "C",
      };

      _this.viewData.card.useTerm = _this.$aroApiBasePath + AroConst.VALUE_AGG_LOC_ME_CARD_USE_TERM_SHIPPING;

      _this.$refs.cardInfoPanel.initData({card:_this.viewData.card});
    },

    /**
     * Util
     */
    numberKeyPress(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },

    keyUpToNumber(evt){
      evt = (evt) ? evt : window.event;
      evt.target.value = evt.target.value.replace(/[^0-9]/g, "");
    },
  }
}
</script>
<style>
a.rew19_btn_T1, .rew19_wrapRadio_t1 label{
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/AgelocRewardMileagePaymentDialog.vue